import maintainerApi from 'api/maintainerApi';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import MaintainerListFilterView from './components/MaintainerListFilterView';

const defaultColumnIds = [
    'MAINTAINER_CODE',
    'MAINTAINER_NAME',
    'MAINTAINER_TYPE',
    'COUNTRY',
    'WORK_ADDRESS',
    'ADDRESS',
    'PHONE',
    'EMAIL',
    'STATUS',
    'COMPLETED_TICKET',
    'RECEIVED_INCOME',
    'CREATEDBY',
    'DATE',
];

function MaintainerListView(props) {
    // ---- params ----
    const { t } = useTranslation();
    const router = useRouter();
    const { user, permissionList } = useSelector((state) => state.auth);
    const [operatorList, setOperatorList] = useState([]);
    const [filter, setFilter] = useState(MaintainerHelper.Filter.maintainerList);
    const [filterDropdown, setFilterDropdown] = useState(MaintainerHelper.Filter.maintainerList);

    // khu vuc
    const areaTree = useSelector((state) => state.app.areaTree);
    const areaProvinceList = useMemo(() => {
        return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
    }, [areaTree]);
    const areaProvinceOptions = useMemo(() => {
        return _.map(areaProvinceList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaProvinceList]);
    const [selectedAreaProvince, setSelectedAreaProvince] = useState();
    const areaDistrictList = useMemo(() => {
        if (!selectedAreaProvince) return [];
        return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
    }, [areaTree, selectedAreaProvince]);
    const areaDistrictOptions = useMemo(() => {
        return _.map(areaDistrictList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaDistrictList]);
    const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
    useEffect(() => {
        const areaId = filterDropdown.areaId;
        if (Utils.isValid(areaId)) {
            const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
            if (area?.typeCode === 'P') {
                setSelectedAreaProvince(area);
            } else {
                setSelectedAreaDistrict(area);
                const parentAreaId = area?.parentId;
                if (Utils.isValid(parentAreaId)) {
                    setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
                }
            }
        }
    }, [filterDropdown?.areaId, areaTree]);

    const app = useSelector((state) => state.app);
    const { isGettingData, maintainerList, maintainerTotal } = useSelector((state) => state.maintainer);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'MAINTAINER_CODE',
                name: UIHelper.buildTableColumn('Mã kỹ thuật viên'),
                selector: (row) => row?.agencyCode ?? (row.agencyId),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '130px',
            },
            {
                id: 'MAINTAINER_NAME',
                name: UIHelper.buildTableColumn('Tên kỹ thuật viên'),
                minWidth: '240px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.name ?? ''}>
                            <span>{row?.name ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'MAINTAINER_TYPE',
                name: UIHelper.buildTableColumn('Loại KTV'),
                selector: (row) => t(row.type) ?? 'N/A',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '100px',
            },
            {
                id: 'COUNTRY',
                name: UIHelper.buildTableColumn('Quốc gia'),
                selector: (row) => _.find(AgencyHelper.Data.CountryOptions, { value: row?.country })?.name,
                style: tableStyle.columns.normal,
                minWidth: '150px',
            },
            {
                id: 'WORK_ADDRESS',
                name: UIHelper.buildTableColumn('Địa chỉ đăng ký làm việc'),
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.workAddress?.workAreaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResult = [row?.workAddress?.workAddress, area?.name, parentArea?.name]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResult} offset={[0, 0]}>
                            <span>{addressResult?.length > 0 ? addressResult : ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '240px',
            },
            {
                id: 'ADDRESS',
                name: UIHelper.buildTableColumn('Địa chỉ hiện tại'),
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResult = [row.address, area?.name, parentArea?.name]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResult} offset={[0, 0]}>
                            <span>{addressResult?.length > 0 ? addressResult : ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '240px',
            },
            {
                id: 'PHONE',
                name: UIHelper.buildTableColumn('Số điện thoại'),
                selector: (row) => row.phone ?? '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '140px',
            },
            {
                id: 'EMAIL',
                name: UIHelper.buildTableColumn('Email'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.email ?? ''}>
                            <span>{row?.email ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                minWidth: '250px',
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={t(`agencyStatus_${row.status}`)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${MaintainerHelper.Utils.getMaintainerStatusColor(row.status)}`}
                        />
                    );
                },
                sortable: false,
                minWidth: '130px',
            },
            {
                id: 'COMPLETED_TICKET',
                name: UIHelper.buildTableColumn('Số công việc hoàn thành'),
                selector: (row) => Utils.formatNumber(row?.completedTicket ?? 0),
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '180px',
                right: true,
            },
            {
                id: 'RECEIVED_INCOME',
                name: UIHelper.buildTableColumn('Tổng thu nhập đã nhận', 'VNĐ'),
                selector: (row) => Utils.formatNumber(row?.receivedAmount ?? 0),
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '180px',
                right: true,
            },
            {
                id: 'CREATEDBY',
                name: UIHelper.buildTableColumn('Người tạo'),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.createdBy?.fullname}>
                            <span
                                className="cursor-pointer hover-opacity-60"
                                onClick={() => {
                                    DealerHelper.navigateToParentAgency(row?.createdBy);
                                }}
                            >
                                {row?.createdBy?.fullname}
                            </span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                width: '200px',
            },
            {
                id: 'DATE',
                name: UIHelper.buildTableColumn('Ngày tạo'),
                selector: (row) => Utils.formatDateTimeToString(row.createdAt, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem chi tiết',
                                    click: () => {
                                        handleClickedRow(row);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-bolt"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Kích hoạt tài khoản',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmAcceptMaintainer(row, () => {
                                            getMaintainerList(filter);
                                        });
                                    },
                                    show: row?.status === 'REGISTERED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉnh sửa',
                                    click: () => {
                                        handleShowEditAgency(row);
                                    },
                                    show: (!row?.numberOfSignedContracts || adminRole),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Ngừng hoạt động',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmStopMaintainer(row, () => {
                                            getMaintainerList(filter);
                                        });
                                    },
                                    show: row?.status === 'NORMAL',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Khôi phục hoạt động',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmActiveMaintainer(row, () => {
                                            getMaintainerList(filter);
                                        });
                                    },
                                    show: row?.status === 'SUSPENDED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-file-contract"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo hợp đồng KTV',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmCreateContractWithMaintainer(row, () => { });
                                    },
                                    show:
                                        row?.status !== 'REGISTERED'
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-lock`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Đặt lại mật khẩu',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmChangeMaintainerPassword(row, () => {
                                            getMaintainerList(filter);
                                        });
                                    },
                                    show: adminRole,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xóa kỹ thuật viên',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmDeleteMaintainer(row, () => {
                                            getMaintainerList(filter);
                                        });
                                    },
                                    show: true,
                                },
                            ]}
                        />
                    );
                },
            },
        ];
    }, [t, operatorList, areaTree, user, filter]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    useEffect(() => {
        getMaintainerList(filter);
    }, [filter]);

    const getMaintainerList = (filter) => {
        try {
            let params = { ...filter };
            params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
            MaintainerHelper.API.requestGetMaintainerList(params);
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    };

    // ---- methods ----
    const handleClickedRow = (row) => {
        BreadcrumbHelper.setBreadcrumPath(t('maintainerDetail'), `${router?.pathname}/${row?.agencyId}`);
        router.navigate(`${row.agencyId}`);
    };

    //them dai ly
    const handleOpenAddMaintainerModal = () => {
        BreadcrumbHelper.setBreadcrumPath(t('addMaintainer'), `${router?.pathname}/add`);
        router.navigate('add');
    };

    const handleShowEditAgency = (row) => {
        router.navigate(`${row?.agencyId}/edit`);
    };


    const updateFilter = (key, value) => {
        MaintainerHelper.Filter.maintainerList = { ...MaintainerHelper.Filter.maintainerList, [key]: value };
        setFilter(MaintainerHelper.Filter.maintainerList);
        setFilterDropdown(MaintainerHelper.Filter.maintainerList);
    };

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;
        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const sheetFileName = 'Danh_sách_kỹ_thuật_viên_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
        const ext = '.xlsx';
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(sheetFileName, {
            headerFooter: { firstHeader: sheetFileName },
        });

        sheet.mergeCells('A1:N1');
        sheet.getCell('A1').value = `DANH SÁCH KỸ THUẬT VIÊN (NGÀY ${moment(params.from).format(
            'DD/MM/YYYY'
        )} - ${moment(params.to).format('DD/MM/YYYY')})`;
        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };
        sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };
        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'maintainerCode', width: 18 },
            { key: 'maintainerName', width: 35 },
            { key: 'maintainerType', width: 15 },
            { key: 'country', width: 15 },
            { key: 'workAddress', width: 35 },
            { key: 'address', width: 35 },
            { key: 'phone', width: 22 },
            { key: 'email', width: 30 },
            { key: 'status', width: 20 },
            { key: 'completedTicket', width: 30 },
            { key: 'receivedIncome', width: 30 },
            { key: 'createBy', width: 22 },
            { key: 'date', width: 22 },
        ];
        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };
        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        sheet.getCell('A2').value = 'STT';
        sheet.getCell('B2').value = 'Mã kỹ thuật viên';
        sheet.getCell('C2').value = 'Tên kỹ thuật viên';
        sheet.getCell('D2').value = 'Loại KTV';
        sheet.getCell('E2').value = 'Quốc gia';
        sheet.getCell('F2').value = 'Địa chỉ đăng ký làm việc';
        sheet.getCell('G2').value = 'Địa chỉ hiện tại';
        sheet.getCell('H2').value = 'Số điện thoại';
        sheet.getCell('I2').value = 'Email';
        sheet.getCell('J2').value = 'Trạng thái';
        sheet.getCell('K2').value = 'Số công việc hoàn thành';
        sheet.getCell('L2').value = 'Tổng thu nhập đã nhận (VNĐ)';
        sheet.getCell('M2').value = 'Người tạo';
        sheet.getCell('N2').value = 'Ngày tạo';


        ['A2:N2'].forEach((range) => {
            sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        let i = 1;
        exportDataList?.forEach((row) => {
            // Dia chi dang ky lam viec
            const workArea = ChargeHelper.Utils.getAreaById([areaTree], row?.workAddress?.workAreaId);
            let workParentArea;
            if (workArea?.typeCode === 'W') {
                workParentArea = ChargeHelper.Utils.getAreaById([areaTree], workArea?.parentId);
            }
            const workAddressResult = [row?.workAddress?.workAddress, workArea?.name, workParentArea?.name]
                .filter(Boolean)
                .join(', ');

            // Dia chi hien tai
            const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
            let parentArea;
            if (area?.typeCode === 'W') {
                parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
            }
            const addressResult = [row.address, area?.name, parentArea?.name]
                .filter(Boolean)
                .join(', ');

            const dataRow = sheet.addRow({
                stt: i++,
                maintainerCode: row?.agencyCode ?? (row.agencyId),
                maintainerName: row?.name,
                maintainerType: t(row.type),
                country: _.find(AgencyHelper.Data.CountryOptions, { value: row?.country })?.name,
                workAddress: workAddressResult?.length > 0 ? workAddressResult : '',
                address: addressResult?.length > 0 ? addressResult : '',
                phone: row.phone ?? '',
                email: row?.email ?? '',
                status: t(`agencyStatus_${row.status}`),
                completedTicket: Utils.formatNumber(row?.completedTicket ?? 0),
                receivedIncome: Utils.formatNumber(row?.receivedAmount ?? 0),
                createBy: row?.createdBy?.fullname ?? '',
                date: row?.createdAt ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                if (colNumber === 1) {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                } else if (colNumber >= 11 && colNumber <= 12) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = sheetFileName + ext;
            anchor.click();
            window.URL.revokeObjectURL(url);
            ToastHelper.showSuccess('Tải xuống file Excel thành công');
            AppCustomDialogHelper.hide();
        });
    };

    return (
        <div>
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                Danh sách kỹ thuật viên
                            </span>
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                Tổng số:{' '}
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                    {Utils.formatNumber(maintainerTotal != 0 ? maintainerTotal : maintainerList?.length)} KTV
                                </span>
                            </span>
                        </div>
                        <div>
                            {adminRole && (
                                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                                    {UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            try {
                                                ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                                    MaintainerHelper.Filter.maintainerList,
                                                    async (params) => {
                                                        try {
                                                            const { maintainers = [] } = await maintainerApi.getMaintainerList(params);
                                                            return handleExportExcel(maintainers, params);
                                                        } catch (error) {
                                                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                            return [];
                                                        }
                                                    },
                                                );
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                            }
                                        },
                                        <i className="fa-regular fa-download" />
                                    )}
                                    {UIHelper.buildGreenButton(
                                        'Thêm kỹ thuật viên',
                                        handleOpenAddMaintainerModal,
                                        <i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* table */}
                    <div className="">
                        {/* filter */}
                        <div className="row m-0 p-0 px-2">
                            {/* tim kiem */}
                            <div className="col mb-4 px-2 pt-1">
                                {UIHelper.buildFormLabel('Tìm kiếm')}
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder={t('Theo mã KTV, tên KTV, số điện thoại, email, MST/CCCD...')}
                                    value={MaintainerHelper.Filter.maintainerList.q}
                                    onSubmit={(text) => {
                                        MaintainerHelper.Filter.maintainerList = {
                                            ...MaintainerHelper.Filter.maintainerList,
                                            q: text,
                                            page: 0,
                                        };
                                        setFilter(MaintainerHelper.Filter.maintainerList);
                                        setFilterDropdown(MaintainerHelper.Filter.maintainerList);
                                    }}
                                />
                            </div>
                            {/* loai KTV */}
                            <div className="col mb-4 px-2">
                                <KTDropdownFilter
                                    label={'Loại KTV'}
                                    filterKey="type"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...MaintainerHelper.Data.maintainerTypeOptions
                                    ]}
                                    selectedValue={MaintainerHelper.Filter.maintainerList.type}
                                    handleChange={(value) => {
                                        updateFilter('type', value);
                                        updateFilter('page', 0);
                                    }}
                                />
                            </div>
                            {/* trang thai */}
                            <div className="col mb-4 p-0 px-2">
                                <KTDropdownFilter
                                    label={t('status')}
                                    filterKey="status"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...MaintainerHelper.Data.maintainerStatusOptions
                                    ]}
                                    selectedValue={
                                        MaintainerHelper.Filter.maintainerList.status ||
                                        (MaintainerHelper.Filter.maintainerList.hasSignedContract ? AppConstants.agencyStatus.signed : '')
                                    }
                                    handleChange={(value) => {
                                        const isSigned = value === 'SIGNED';
                                        const newStatus = isSigned ? '' : value;
                                        const newHasSignedContract = isSigned ? 1 : '';

                                        updateFilter('status', newStatus);
                                        updateFilter('hasSignedContract', newHasSignedContract);
                                        updateFilter('page', 0);
                                    }}
                                />
                            </div>
                            {/* ngươi tao */}
                            <div className="col mb-4 p-0 px-2">
                                <KTDropdownFilter
                                    label={t('Người tạo')}
                                    filterKey="createdBy"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...MaintainerHelper.Data.maintainerCreatedByOptions
                                    ]}
                                    selectedValue={MaintainerHelper.Filter.maintainerList.createdBy}
                                    handleChange={(value) => {
                                        updateFilter('createdBy', value);
                                    }}
                                />
                            </div>
                            <div className="col mb-4 p-2 d-flex align-items-end gap-3">
                                {/* bo loc */}
                                <DropdownFilterTable
                                    filterComponent={[
                                        <div>
                                            <MaintainerListFilterView
                                                setFilterDropdown={setFilterDropdown}
                                                filterDropdown={filterDropdown}
                                                areaProvinceOptions={areaProvinceOptions}
                                                areaDistrictOptions={areaDistrictOptions}
                                                selectedAreaDistrict={selectedAreaDistrict}
                                                setSelectedAreaDistrict={setSelectedAreaDistrict}
                                                selectedAreaProvince={selectedAreaProvince}
                                                setSelectedAreaProvince={setSelectedAreaProvince}
                                                areaProvinceList={areaProvinceList}
                                                areaDistrictList={areaDistrictList}
                                            />
                                        </div>
                                    ]}
                                    resetDefaultTable={() => {
                                        const updateFilterDropdown = {
                                            ...filterDropdown,
                                            operatorId: '',
                                            status: '',
                                            type: '',
                                            from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
                                            to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
                                            selectedValue: dateFilter.tatCaThoiGian,
                                            areaId: '',
                                            q: '',
                                            createdBy: '',
                                            hasSignedContract: '',
                                            country: '',
                                        };
                                        setFilterDropdown(updateFilterDropdown);
                                        setFilter(updateFilterDropdown);
                                        MaintainerHelper.Filter.maintainerList = updateFilterDropdown;
                                        setSelectedAreaProvince('');
                                        setSelectedAreaDistrict('');
                                    }}
                                    saveFilter={() => {
                                        setFilter(filterDropdown);
                                        MaintainerHelper.Filter.maintainerList = filterDropdown;
                                    }}
                                    isDefaultFilter={Utils.checkDefaultFilter(
                                        ['role', 'page', 'limit', 'from', 'to', 'selectedValue'],
                                        filter
                                    )}
                                />
                                {/* cau hinh cot */}
                                <DropdownTableConfigColumn
                                    columnIds={columnIds}
                                    fullColumns={fullColumns}
                                    fullColumnIds={fullColumnsIdSorted}
                                    onChangeCheckboxValue={onChangeCheckboxValue}
                                    saveChanges={saveChanges}
                                    resetDefaultTableColumn={() => {
                                        setFullColumnIds(defaultColumnIds);
                                        resetDefaultTableColumn();
                                    }}
                                    onChangeFullColumnIds={(ids) => {
                                        setFullColumnIds(ids);
                                        const key = prefKey + '_FULL_COLUMN_IDS';
                                        localStorage.setItem(key, ids.join('|'));
                                    }}
                                    onSelectAll={onSelectAll}
                                    onUnSelectAll={onUnSelectAll}
                                />
                            </div>
                        </div>

                        <div className="px-4">
                            <KTTable
                                columns={columns}
                                items={maintainerList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                        </div>
                    </div>

                    {/* pagination */}
                    <div className="px-4 mt-2">
                        <KTPagination
                            currentPage={filter.page + 1}
                            rowCount={maintainerTotal != 0 ? maintainerTotal : maintainerList?.length}
                            rowsPerPage={filter.limit}
                            currentItemInPageCount={maintainerList?.length}
                            onChangePage={(newPage) => {
                                const iNewPage = parseInt(newPage);
                                MaintainerHelper.Filter.maintainerList = {
                                    ...MaintainerHelper.Filter.maintainerList,
                                    page: iNewPage - 1,
                                };
                                setFilter(MaintainerHelper.Filter.maintainerList);
                            }}
                            onChangeRowsPerPage={(newRowsPerPage) => {
                                const iNewRowsPerPage = parseInt(newRowsPerPage);
                                MaintainerHelper.Filter.maintainerList = {
                                    ...MaintainerHelper.Filter.maintainerList,
                                    limit: iNewRowsPerPage,
                                    page: 0,
                                };
                                setFilter(MaintainerHelper.Filter.maintainerList);
                            }}
                            loading={isGettingData}
                            color={KTPaginationColor.success}
                            appendText="KTV"
                        />
                    </div>
                </div>,
                false
            )}
        </div>
    );
}

export default MaintainerListView;
